"use strict";

/**
 * @module Client.Services
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pingService = void 0;
/**
 * Service implementation to provide Ping functionality.
 *
 * Intended to provide basic Ping functionality by immediately responding to a
 * received request, by which the round-trip latency between the sender and
 * receiver may be ascertained.
 */
exports.pingService = {
  /**
   * Handle an inbound request
   *
   * @param internal  the internal session instance
   * @param ping      the inbound ping request
   * @param callback  the service reference callback
   */
  onRequest: function onRequest(internal, ping, callback) {
    callback.respond();
  }
};